// number of characters we send to an LLM for context
export const CUTOFF = 3000;

// this came from ./create-chat, but for all frame types
export const AI_ASSIST_TAG = "code-editor";
